module.exports = require("./ar-QA.d.ts");